import { render } from "./BusinessLicenseImg.vue?vue&type=template&id=4f3a3c77&scoped=true"
import script from "./BusinessLicenseImg.vue?vue&type=script&lang=js"
export * from "./BusinessLicenseImg.vue?vue&type=script&lang=js"

import "./BusinessLicenseImg.vue?vue&type=style&index=0&id=4f3a3c77&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3a3c77"]])

export default __exports__